import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SearchEnrollmentBuilder, SearchEnrollmentRequest } from "src/app/domain/model/search/search-enrollment-request";
import { SearchEnrollmentResponse } from "src/app/domain/model/search/search-enrollment-response";
import { SearchRepository } from "src/app/domain/repositories/search/search.repository";
import { SearchEnrollmentMapper } from "./mappers/search-enrollment.mapper";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map } from 'rxjs/operators';
import { TypeSearchinUtil, TypeSearchingBy } from "src/app/domain/model/TypeSearchingBy";
import { DataBuilder, Metadata } from "src/app/base/model/data-body-request";
import { SearchEnrollmentDto } from "./dto/search-enrollment.dto";
import { DataBodyResponse } from "src/app/base/model/data-body-response";
import { ProcessedDataResponse } from "src/app/base/model/processed-data-response";
import { StorageService } from "src/app/services/storage.service";


@Injectable({
    providedIn: 'root',
})
export class SearchImplementationRepository extends SearchRepository {
    urlServices = environment.urlServiceCommon;

    userMapper = new SearchEnrollmentMapper();
    constructor(
        private http: HttpClient,
        protected storageService: StorageService
    ) {
        super(storageService);
    }

    searchEnrollment(
        params: {
            dataToSearch: string,
            typeSearchingBy: TypeSearchingBy,
            metadata: Metadata,
        }
    ): Observable<ProcessedDataResponse<SearchEnrollmentDto>> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const options = { headers };
        return this.http
            .post<DataBodyResponse<[SearchEnrollmentResponse]>>(
                `${this.urlServices}/bid/rest/v1/people/findEnrollmentPersonTMV`,
                this.buildSearchRequest(params),
                options
            )
            .pipe(map(this.userMapper.map))
    }

    private buildSearchRequest(
        params: {
            dataToSearch: string,
            typeSearchingBy: TypeSearchingBy,
            metadata: Metadata,
        }
    ) {
        let builder = new SearchEnrollmentBuilder()
        let dataBuilder = new DataBuilder()
        switch (params.typeSearchingBy) {
            case TypeSearchingBy.email:
                builder.buildSearchBy(TypeSearchinUtil.toString(TypeSearchingBy.email))
                builder.buildEmail(params.dataToSearch)
                console.log('TypeSearchingBy email');
                break;
            case TypeSearchingBy.identification:
                builder.buildSearchBy(TypeSearchinUtil.toString(TypeSearchingBy.identification))
                builder.buildIdentification(params.dataToSearch)
                console.log('TypeSearchingBy RFC');
                break;

            default:
                console.log(`non-existent type`);
                break;
        }
        dataBuilder.buildData(builder.getResult())
        this.getOperationID(dataBuilder)
        dataBuilder.buildMetaData(params.metadata)
        return dataBuilder.getResult()
    }
}